module.exports = __webpack_public_path__ + "media/images/x-990bca2d66eaa334e43df29ae57f387a2d59b228153fb084e5e93bc7d8cf279c.svg";